import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NewContactsService } from './service';

interface ContactState {
    showRecallContactModal: boolean
    // contactToWork?: {
    //     contactId: string
    //     name: string
    //     surname: string
    //     phone: string
    //     privacy: boolean
    // }
    listIndexToHighlight?: number
}

const initialState: ContactState = {
    showRecallContactModal: false,
};

export const updateSendEmails = createAsyncThunk(
    "contacts/updateSendEmails",
    async (
        request: {
            contactId: string;
            sendEmails: string[]
        },
        thunkApi
    ): Promise<void> => {
        const ContactsService = NewContactsService();

        return ContactsService.updateSendEmails(
            request.contactId,
            request.sendEmails
        );
    }
)

const contactsSlice = createSlice({
    name: 'contacts',
    initialState,
    reducers: {
        setShowRecallContactModal: (state, action) => {
            state.showRecallContactModal = action.payload
        },
        // setContactToWork: (state, action) => {
        //     state.contactToWork = action.payload
        // },
        setListIndexToHighlight: (state, action) => {
            state.listIndexToHighlight = action.payload
        }
    },
    extraReducers(builder) {
    },
});

export const {
    // setContactToWork,
    setListIndexToHighlight,
    setShowRecallContactModal,
} = contactsSlice.actions;
export default contactsSlice.reducer;
